export default {
  brand1: process.env.REACT_APP_THEME_COLORS_BRAND1 || '#a43070',
  brand2: process.env.REACT_APP_THEME_COLORS_BRAND2 || '#0f89da',
  brand3: process.env.REACT_APP_THEME_COLORS_BRAND3 || '#1dbdb5',
}
